// 在 main.js 中异步加载配置
async function loadConfig() {
	return new Promise((resolve) => {
		try {
			(function getmsg() {
				if (window.mainbodyConfig) {
					resolve();
				} else {
					setTimeout(() => {
						getmsg();
					}, 10);
				}
			})();

		} catch (error) {
			console.warn('Error loading external config, using default config:', error);
			resolve();
		}
	});
}

import { createApp } from 'vue';
import App from './App.vue';
import Vant from 'vant';
import 'vant/lib/index.css'; // 引入样式
import { showToast, showConfirmDialog, showImagePreview, Locale } from 'vant';
// 引入英文语言包
import enUS from 'vant/es/locale/lang/en-US';
import viVN from 'vant/es/locale/lang/vi-VN';

import router from './router';
import moment from 'moment';
import 'moment/locale/zh-cn'   // ✅ 加这行
import 'moment/locale/vi'      // ✅ 加这行
import mitt from 'mitt';
import Md5 from 'spark-md5';
import VConsole from 'vconsole';
import request from '@/common/js/request.js';
import methods from '@/common/js/methods.js';
import constant from '@/common/js/constant.js';
import { useStore } from '@/store';
let store = useStore();
import loading from '@/components/loading';
import tologinVue from '@/components/customizeNav/tologin';
import { traceRootSpan, recordPageLoadDuration } from './common/js/otel-config.js';


//导入推送
import Socket from '@/common/js/socket.js';
import { pageLevel } from '@/router'
import VueClipboard from 'vue3-clipboard';

import { createI18n } from 'vue-i18n';
const initStartTime = performance.now();
window.__pageLevel = pageLevel
// 在创建应用前加载配置
loadConfig().then(async () => {

	const app = createApp(App);
	// ========== 全局错误捕获（关联 OTel） ==========
// 在 Vue 原型上添加全局变量
window.globalConfig = {
	showMatchStatusAndLineup: false  // 默认不显示
  };
	app.config.errorHandler = (err, instance, info) => {
		traceRootSpan('vue-global-error', (span) => {
			span.setAttribute('error.instance', instance?.$options?.name || 'unknown');
			span.setAttribute('error.info', info);
			span.setAttribute('error.message', err.message);
			span.setAttribute('error.stack', err.stack);
			console.error('Vue 全局错误,', err, instance, info);
		}).catch(() => { }); // 忽略埋点自身错误
	};
	let mitter = new mitt();
	app.config.globalProperties.mitter = mitter;
	app.config.globalProperties.moment = moment;
	app.config.globalProperties.Md5 = Md5;
	app.config.globalProperties.VConsole = VConsole;

	Object.keys(methods).forEach(k => app.config.globalProperties[k] = methods[k]);//注入方法
	app.config.globalProperties.constant = constant;
	app.config.globalProperties.mainbodyConfig = window.mainbodyConfig;

	request.domain.updateList(window.mainbodyConfig.api_domians);

	request.store = store;
	request.router = router;
	request.mitter = mitter;
	request.showToast = showToast;
	app.config.globalProperties.request = request;


	const savedLanguage = localStorage.getItem('qx2_language');
	let userLanguage = savedLanguage || navigator.language.split('-')[0] || 'zh';
	if (userLanguage.startsWith('zh')) {
		userLanguage = 'zh';
	} else if (userLanguage.startsWith('vi')) {
		userLanguage = 'vi';
	} else {
		userLanguage = 'en';
	}
	if (userLanguage == 'zh') {
		app.config.globalProperties.moment.locale('zh-cn');
	} else if (userLanguage == 'vi') {
		app.config.globalProperties.moment.locale('vi');
		Locale.use('vi-VN', viVN);
	} else {
		app.config.globalProperties.moment.locale(userLanguage);
		Locale.use('en-US', enUS);
	}
	// userLanguage = 'en';
	let messages = {
		en: require('@/locale/en.json'),
		vi: require('@/locale/vi.json'),
		zh: require('@/locale/zh-Hans.json')
	}
	const i18n = createI18n({
		legacy: false,  // 使用 Composition API
		flatJson: true,
		locale: userLanguage,   // 默认语言
		fallbackLocale: 'en',  // 默认回退语言
		messages
	});
	//挂载i18n实例
	window.__i18n = i18n;


	// ========== 追踪应用初始化 ==========
	await traceRootSpan('vue-app-init', (span) => {
		app.use(router);
		app.use(i18n); // 使用i18n实例
		app.component('Loading', loading);
		app.component('toLoginVue', tologinVue);
		app.use(Vant); // 全局注册所有组件
		app.config.globalProperties.showToast = showToast;
		app.config.globalProperties.showConfirmDialog = showConfirmDialog;
		app.config.globalProperties.showImagePreview = showImagePreview;
		// 全局挂载 Socket
		const socket = new Socket({ methods, request, mitter, WS_API: window.mainbodyConfig.WS_API });
		socket.init();
		app.config.globalProperties.Socket = socket;

		app.use(VueClipboard, {
			autoSetContainer: true,
			appendToBody: true,
		})

		app.mount('#app')
			.$nextTick(() => {
				const loadDuration = performance.now() - initStartTime;
				// 记录初始页面加载耗时（带标签区分场景）
				recordPageLoadDuration(loadDuration, window.__my_res_ver, window.location.href, 'initial');
			});
	});
}).catch((error) => {
	console.error('Error loading external config:', error);
});

const resizeObserver = (window).ResizeObserver;
(window).ResizeObserver = class ResizeObserver extends resizeObserver {
	constructor(callback) {
		callback = methods.throttle(callback, 0, 100);
		super(callback);
	}
};
